import { AdPlacement } from "@/components/ads/AdPlacement";
import { m } from "@/paraglide/messages";
import { CountdownTimer } from "../components/CountdownTimer";
import { PresetGrid } from "../components/PresetGrid";
import { TimerBreadcrumb } from "../components/TimerBreadcrumb";
import { TimerExplainer } from "../components/TimerExplainer";

export function TimerIndex() {
  return (
    <div className="pct-page relative min-h-screen">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-96 pct-glow" />
      <div className="relative mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
        <TimerBreadcrumb />

        <header className="mb-8 mt-6">
          <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">
            {m.timer_hub_h1()}
          </h1>
          <p className="mt-3 leading-relaxed text-muted-foreground">
            {m.timer_hub_intro()}
          </p>
        </header>

        <CountdownTimer initialSeconds={300} editable />

        <TimerExplainer
          howTo={m.timer_hub_howto()}
          faqs={[
            { q: m.timer_hub_faq1_q(), a: m.timer_hub_faq1_a() },
            { q: m.timer_hub_faq2_q(), a: m.timer_hub_faq2_a() },
            { q: m.timer_hub_faq3_q(), a: m.timer_hub_faq3_a() },
            { q: m.timer_hub_faq4_q(), a: m.timer_hub_faq4_a() },
          ]}
        />

        <AdPlacement className="mt-10" />
        <PresetGrid />
      </div>
    </div>
  );
}
